module.exports = __webpack_public_path__ + "img/background.7f3e01a8.svg";